module.exports = __webpack_public_path__ + "img/titleid.397ef485.png";